import {NatPostCommunicationPlatform} from './NatPostCommunicationPlatform'

import Http from '../../../../network/Http'
import {ContentType} from '../../../../network/Constants';

export default class NatCommunicationPlatformRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http
    }

    // コミュニケーションプラットフォーム利用登録
    async postCommunicationPlatform()
        : Promise<NatPostCommunicationPlatform> {
        return await this.http.post(
            `/api/resident/residentUser/communicationPlatform`,
            {},
            ContentType.JSON,
        );
    }
}
